export const PLATFORM_OPTIONS = [
  {
    id: 1,
    name: "Facebook",
    label: "Facebook",
    isSelected: false,
  },
  {
    id: 2,
    name: "Instagram",
    label: "Instagram",
    isSelected: false,
  },
  {
    id: 3,
    name: "Audience Network",
    label: "Audience Network",
    isSelected: false,
  },
  {
    id: 4,
    name: "Messenger",
    label: "Messenger",
    isSelected: false,
  },
];

export const DEVICE_OPTIONS = [
  {
    id: 1,
    name: "Desktop",
    label: "Desktop",
    isSelected: false,
  },
  {
    id: 2,
    name: "Mobile",
    label: "Mobile",
    isSelected: false,
  },
];
